export enum PrivateRoute {
    Chat = '',
}
